import { FC, useCallback } from 'react';
import { alpha, Box, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../atomic/atoms';
import type { ShipmentRow } from '../autoReturnAndResend.types';
import { exportPanelToExcel } from '../autoReturnAndResend.helpers';
import { AutoReturnAndResendPanelHeader } from './AutoReturnAndResendPanelHeader';
import { ARAR } from '../autoReturnAndResend.classes';

interface AutoReturnAndResendNotFoundPanelProps {
    rows: ShipmentRow[];
}

export const AutoReturnAndResendNotFoundPanel: FC<AutoReturnAndResendNotFoundPanelProps> = ({ rows }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const handleExportExcel = useCallback(() => {
        exportPanelToExcel(
            rows,
            [{ key: 'shippingListNo', label: t('general.shippingNo'), resolve: (row) => row.shippingListNo }],
            'Bulunamayan'
        );
    }, [rows, t]);

    return (
        <Box className={ARAR.panelSection}>
            <AutoReturnAndResendPanelHeader
                actions={
                    <SCUIButton
                        text={t('rpaResender.exportToExcel')}
                        type="secondary"
                        sizeType="default"
                        size="m"
                        disabled={rows.length === 0}
                        onClick={handleExportExcel}
                    />
                }
            />
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    p: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    backgroundColor: alpha(theme.palette.error.main, 0.04),
                    minHeight: 80,
                }}
            >
                {rows.length === 0 ? (
                    <Chip color="default" variant="outlined" label={t('general.noData')} />
                ) : (
                    rows.map((row) => (
                        <Chip
                            key={row.shippingListNo}
                            color="error"
                            variant="outlined"
                            label={row.shippingListNo}
                        />
                    ))
                )}
            </Box>
        </Box>
    );
};
